// extracted by mini-css-extract-plugin
export var bg = "index-module--bg--Fc7kA";
export var btnWrapper = "index-module--btnWrapper--33b9i";
export var buttonContainer = "index-module--buttonContainer--V68dh";
export var container = "index-module--container--IeFL-";
export var footerContainer = "index-module--footerContainer--B-QHQ";
export var paragraph = "index-module--paragraph--Yb8tN";
export var section = "index-module--section--5dEbm";
export var sectionContainer = "index-module--sectionContainer--HhyyQ";
export var title = "index-module--title--1yc6n";